import { deviceDTOSchema, deviceSessionDTOSchema, pairedDeviceDTOSchema, pairingCodeDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, DEVICE_API_PREFIX, listEnvelopeSchema, WEB_API_PREFIX, } from '../transport.js';
const listDevicesSchema = listEnvelopeSchema(deviceDTOSchema);
const pairingCodeSchema = dataEnvelopeSchema(pairingCodeDTOSchema);
const pairedDeviceSchema = dataEnvelopeSchema(pairedDeviceDTOSchema);
const deviceSessionSchema = dataEnvelopeSchema(deviceSessionDTOSchema);
export function createDevicesResource(transport) {
    return {
        async list(query) {
            return transport.request({
                path: `${WEB_API_PREFIX}/devices`,
                schema: listDevicesSchema,
                query: query === undefined
                    ? undefined
                    : {
                        page: query.page,
                        pageSize: query.pageSize,
                        sort: query.sort,
                        locationId: query.locationId,
                    },
            });
        },
        async createPairingCode(input) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/devices/pairing-codes`,
                schema: pairingCodeSchema,
                body: input,
            });
            return envelope.data;
        },
        async revoke(id) {
            await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/devices/${encodeURIComponent(id)}/revoke`,
                schema: z.undefined(),
            });
        },
        async pair(input) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${DEVICE_API_PREFIX}/devices/pair`,
                schema: pairedDeviceSchema,
                body: input,
                auth: 'none',
            });
            return envelope.data;
        },
        async me() {
            const envelope = await transport.request({
                path: `${DEVICE_API_PREFIX}/devices/me`,
                schema: deviceSessionSchema,
                auth: 'device',
            });
            return envelope.data;
        },
        async heartbeat(appVersion) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${DEVICE_API_PREFIX}/devices/heartbeat`,
                schema: deviceSessionSchema,
                body: appVersion === undefined ? undefined : { appVersion },
                auth: 'device',
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=devices.js.map